/*
 * OBSOLETE - use google tag manager service instead:
 * src\EbaySweden.TouchWeb\static\script\app\ui\google-tagmanager-service.js
 *
 */

export default new (function() {
    var timers = {};
    var sentCounter = {};

    function pushToDataLayer(payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    }

    this.trackAddonAfterPublish = function(addOnfeatureName) {
        const isPageOpenedFromMail =
            window.location.pathname.indexOf('/selling/features') > -1;
        const label = isPageOpenedFromMail
            ? 'After Publish Mail'
            : 'After Publish';
        this.trackEvent({
            category: 'Listing AddOns',
            action: addOnfeatureName,
            label: label
        });
    };

    this.trackAddonBeforePublish = function(addOnfeatureName) {
        this.trackEvent({
            category: 'Listing AddOns',
            action: addOnfeatureName,
            label: 'Before Publish'
        });
    };

    this.trackPageView = function() {
        pushToDataLayer({ event: 'trackPageview' });
    };

    this.trackTiming = function(analyticsData) {
        pushToDataLayer({
            event: 'timing',
            timingCategory: analyticsData.category || '',
            timingVar: analyticsData.variable || '',
            timingValue: analyticsData.value || '',
            timingLabel: analyticsData.label || ''
        });
    };

    this.startTimer = function(name) {
        timers[name] = new Date().getTime();
        sentCounter[name] = 0;
    };

    this.sendTimer = function(name, analyticsData) {
        var duration = +new Date().getTime() - timers[name];

        analyticsData.label = Math.round(duration / 1000) + ' s';

        this.trackSellItemEvent(analyticsData);

        sentCounter[name] += 1;
    };

    this.sendTimerOnce = function(name, analyticsData) {
        if (sentCounter[name] === 0) {
            this.sendTimer(name, analyticsData);
        }
    };

    this.trackEvent = function(analyticsData) {
        pushToDataLayer({
            event: 'trackEvent',
            eventCategory: analyticsData.category || '',
            eventAction: analyticsData.action || '',
            eventLabel: analyticsData.label || '',
            eventValue: analyticsData.value || '0'
        });
    };
})();
